import { InputControls } from 'components/common'
import React, { useEffect, useState } from 'react'
import Select, { components } from 'react-select'
// import { CustomInput } from 'reactstrap'
import { lang } from 'utils/helpers'
import './styles.scss'

// eslint-disable-next-line react/display-name
export default (props) => {
  const handleBlur = () => (props.onBlur ? props.onBlur(props.name, true) : '')
  const {
    id,
    label,
    options,
    value,
    multi = false,
    name,
    placeholder,
    otherProps,
    classNameWrapper,
    iconAlt,
    selectedValues,
    grouped = true,
    hideSelectedOptions = false,
    isClearable = false,
    styles,
    isOptionDisabled,
    isDisabled,
    required,
    isRequiredAll = false,
    closeMenuOnSelect = false,
    className,
    onMenuOpen,
    labelWithSelected,
    labelCustomSelected,
    fullWidth
  } = props
  const [optionValues, setOptionValues] = useState(options)

  const handleChange = (value, data) => {
    if (data?.action === 'deselect-option' && data?.option?.value === 'all' && isRequiredAll) {

      props.onChange([], data)
    }
    else {
      try {
        if (value && value?.length) {
          if (data?.action === 'select-option' && data?.option?.value === 'all' && isRequiredAll) {
            //props.onChange(optionValues, data)
            if (selectedValues && selectedValues.length === options.length)
              props.onChange([], data)
            else
              props.onChange(options, data)
          }
          else {
            if (data?.action === 'deselect-option' && data?.option?.value !== 'all' && isRequiredAll) {
              props.onChange(value.filter(it => it.value !== 'all'), data)
            }
            else {
              props.onChange(value, data)
            }
          }
        }
        else {
          props.onChange(value, data)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  useEffect(() => {
    let _options = multi && isRequiredAll ? [{ value: 'all', label: lang('dashboard_select_all') }].concat(options) : options
    setOptionValues(_options)
  }, [options])

  const Option = (props) => {
    let checked
    const selectedValues = props.selectProps.selectedValues
    if (selectedValues?.length) {
      const checkedValue = selectedValues.find(
        (el) => el.value === props.data.value
      )
      checked = checkedValue ? !!checkedValue : props.isSelected
    } else {
      checked = props.isSelected
    }

    return (
      <div>
        <components.Option {...props} className='filters-wrapper'>
          <InputControls
            injectType='external'
            type='checkbox'
            value={props.value === 'all' && (selectedValues?.length > 0 && selectedValues?.length < props.options.length)
              ? 'some'
              : checked
            }
            onChange={() => null }
            color='newPrimary'
          />
          {/* <CustomInput
            id={props.value}
            type='checkbox'
            checked={props.value === 'all' ? 'some' : checked}
            onChange={() => null}
            className={'filters-check'}
          /> */}
          <label className='filters-label'>{props.label}</label>
        </components.Option>
      </div>
    )
  }

  const MultiValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <span>
          {props.selectProps.value.length > 1
            ? labelWithSelected
              ? labelWithSelected
              : `${props.selectProps.value.length} ${labelCustomSelected? labelCustomSelected: lang('label_selected')}`
            : props.data.label
          }
        </span>
      </components.SingleValue>
    )
  }

  const labelSelect = () => {
    if(selectedValues && selectedValues.length === options.length)
      return lang('dashboard_all')
    if(selectedValues && selectedValues.length < options.length && selectedValues.length > 0)
      return lang(`selector_options_${selectedValues.length === 1 ? 'one' : 'some'}`)
    return lang('dashboard_none')
  }

  return (
    <div
      className={`
        select-label-wrapper
        ${classNameWrapper}
        ${!label && 'normal-height'}
        ${iconAlt && 'icon-alt'}
        ${!grouped && 'select-label-wrapper-full'}
        ${required && 'select-label-wrapper-required'}
        ${fullWidth && 'full-width'}
      `}
    >
      <div className='select-label-wrapper-inner'>
        {label && <label htmlFor={id}>{label}</label>}
        <Select
          id={id}
          name={name}
          //options={optionValues}
          //options={!isRequiredAll ? optionValues :  optionValues.map(it => it.value === 'all' ? {value: 'all', label: selectedValues?.length && selectedValues.find(it => it.value === 'all') ? lang('dashboard_deselect_all') : lang('dashboard_select_all')} : it)}
          options={!isRequiredAll ? optionValues : optionValues.map(it => it.value === 'all' ? { value: 'all', label: labelSelect() } : it)}
          noOptionsMessage={() => lang('select_text_noOptions')}
          isMulti={multi}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
          className={`select-label-container ${className}`}
          classNamePrefix={'select-label'}
          placeholder={placeholder || lang('dashboard_select')}
          components={multi && grouped ? { Option, MultiValue } : null}
          hideSelectedOptions={hideSelectedOptions}
          backspaceRemovesValue={false}
          // selectedValues={selectedValues}
          selectedValues={selectedValues && selectedValues.length === options.length ? [{ value: 'all', label: lang('dashboard_select_all') }].concat(selectedValues) : selectedValues}
          isClearable={isClearable}
          styles={{
            option: (provided, state) => {
              return ({
                ...provided,
                color: state.isDisabled ? '#b5b5b5 !important' : 'unset',
                backgroundColor: state.isDisabled ? '#ffffff !important' : 'unset',
              })},
            ...styles
          }}
          isOptionDisabled={isOptionDisabled}
          isDisabled={isDisabled}
          blurInputOnSelect={false}
          closeMenuOnSelect={multi ? closeMenuOnSelect : true}
          onMenuOpen={onMenuOpen}
          {...otherProps}
        />
      </div>
      {required && <span className='required'>*</span>}
    </div>
  )
}
